import VideoCam from '@mdi/svg/svg/video.svg?react';
import { Button, ButtonMenu, MDIIcon } from '@solinkcorp/solink-components';
import React from 'react';
import useLocale from 'src/hooks/useLocale';
import { type ExternalVms } from 'utils/externalVms';
import { openExternalVms } from 'utils/orchidPlayer';

interface ExternalVmsMenuProps {
  vms: ExternalVms;
  accessToken: string;
  colorMode?: 'light' | 'dark';
}

const ExternalVmsMenu: React.FC<ExternalVmsMenuProps> = ({
  vms,
  accessToken,
  colorMode = 'light',
}) => {
  const locale = useLocale();
  const menuItems = buildMenuItems(vms, accessToken);
  if (menuItems.length === 0) return null;

  // Single camera — skip dropdown, open player directly.
  // Most events have only one camera (DollarTree typical setup).
  // If multi-camera becomes the norm, consider always showing the dropdown for consistency.
  if (menuItems.length === 1) {
    return (
      <Button
        icon={<MDIIcon icon={VideoCam} size={18} />}
        tooltip={locale.event.openExternal}
        iconOnly
        type="clear"
        colorMode={colorMode}
        onClick={menuItems[0].onClick}
      />
    );
  }

  return (
    <ButtonMenu
      buttonIcon={<MDIIcon icon={VideoCam} size={18} />}
      buttonTooltip={locale.event.openExternal}
      buttonIconOnly
      buttonType="clear"
      colorMode={colorMode}
      menuItems={menuItems}
    />
  );
};

function buildMenuItems(vms: ExternalVms, accessToken: string) {
  switch (vms.vendor) {
    case 'orchid':
      return vms.cameras.map((camera) => ({
        icon: <MDIIcon icon={VideoCam} size={18} />,
        text: camera.name ?? `Camera ${camera.id}`,
        onClick: () => openExternalVms(vms, accessToken, camera),
        type: 'action' as const,
      }));
    default:
      return [];
  }
}

export default ExternalVmsMenu;
